import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { productData } from "./ProductData";
import { Link } from "react-router-dom";
import Products from "./Products";
import "./Products.css";

function SingleProduct() {
  const { id } = useParams();
  const product = productData.find((item) => item.id === parseInt(id));
  const [enabled, setEnabled] = useState(true);
  let navigate = useNavigate();
  if (!product) {
    return;
  }

  return (
    <>
      <Products />
      <section>
        <div className="singleProduct" onClick={() => setEnabled(!enabled)}>
          <div className="singleProductInner">
            <div className="picPan">
              <img
                className="singleProductImg"
                src={product.img}
                alt={product.name}
              />
            </div>
            <div className="textPan dark">
              <div className="sideHeading">{product.name}</div>
              {/* <div>{product.prize}</div> */}
              <p className="aboutProduct">
                Creative Balloons is a trusted manufacturer and supplier of
                premium quality Inflatable Characters, Advertising Balloons, and
                other products. We have been in business since 2011, and our
                extensive range of products includes Advertising Air Dancers,
                Hot Air Shape Sky Balloons, Airship Sky Balloons, Back Pack
                Balloons, Android Walking Balloons, and Hanuman Ji Walking
                Inflatables, as well as Inflatable Arches, Inflatable Slide
                Bouncies, VIP Pizza Rubber Balloons, ACC Pole Balloons, Hanging
                Balloons, Walking Inflatables, Sky Balloon Manufacturers in
                Hyderabad, Advertising Balloon Manufacturers in Hyderabad,
                Inflatable Transparent Balls, and many more.
              </p>
              <Link to="/Contact" className="button">
                CONTACT US
              </Link>
            </div>
            <Link
              className="removeBtn"
              onClick={() => navigate(-1)}
              to="/Products"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 5L5 19M5 5L19 19"
                  stroke="#141B34"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default SingleProduct;
